import { Reducer } from 'redux';
import { DevicesTypes, DevicesState } from './types';

const INITIAL_STATE: DevicesState = {
  devicesList: [],
  deviceData: {
    id: '',
    type: '',
    value: '',
    label: '',
    status: null,
    lastUsedAt: '',
    createdAt: '',
    updatedAt: '',
    userId: '',
  },
  totalCount: 0,
  error: false,
  loading: false,
};

const reducer: Reducer<DevicesState> = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    // CASES LIST DEVICE
    case DevicesTypes.LIST_DEVICE_REQUEST:
      return {
        ...state,
        loading: true,
        error: false,
        deviceData: INITIAL_STATE.deviceData,
      };

    case DevicesTypes.LIST_DEVICE_SUCCESS:
      return {
        ...state,
        loading: false,
        error: false,
        deviceData: action.payload.deviceData,
        totalCount: action.payload.totalCount,
      };

    case DevicesTypes.LIST_DEVICE_FAILURE:
      return {
        ...state,
        loading: false,
        error: true,
        deviceData: INITIAL_STATE.deviceData,
      };

    // CASES LIST DEVICES
    case DevicesTypes.LIST_DEVICES_REQUEST:
      return {
        ...state,
        loading: true,
        error: false,
        devicesList: INITIAL_STATE.devicesList,
      };

    case DevicesTypes.LIST_DEVICES_SUCCESS:
      return {
        ...state,
        loading: false,
        error: false,
        devicesList: action.payload.devicesList,
        totalCount: action.payload.totalCount,
      };

    case DevicesTypes.LIST_DEVICES_FAILURE:
      return {
        ...state,
        loading: false,
        error: true,
        devicesList: INITIAL_STATE.devicesList,
      };

    default:
      return state;
  }
};

export default reducer;
